import { render, staticRenderFns } from "./Incompleto.vue?vue&type=template&id=1c58e6d0"
import script from "./Incompleto.vue?vue&type=script&lang=js"
export * from "./Incompleto.vue?vue&type=script&lang=js"
import style0 from "./Incompleto.vue?vue&type=style&index=0&id=1c58e6d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports